import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TrendingUp } from "lucide-react";
import { fetchTrendingVideos, BRAND_VIDEO_POSTER } from "@/lib/api";
import { ViewsBadge } from "@/components/VideoCard";

export default function TrendingStrip() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchTrendingVideos(8).then((v) => setVideos(v || [])).catch(() => {});
  }, []);

  if (videos.length === 0) return null;
  const loop = videos.length >= 4 ? [...videos, ...videos] : videos;

  return (
    <section data-testid="home-trending-strip" className="bg-sand-100 border-y border-sand-200 py-12 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-6 flex items-center gap-3">
        <TrendingUp size={16} className="text-brand-500" />
        <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-sand-900">Trending on Tastebuds TV</span>
      </div>
      <div className="marquee-pause">
        <div className={videos.length >= 4 ? "ticker-marquee gap-6" : "flex gap-6 max-w-7xl mx-auto px-6 md:px-12"}>
          {loop.map((v, i) => {
            const path = v.entity_type === "restaurant" ? `/directory/${v.entity_id}` : `/profile/${v.entity_id}`;
            return (
              <Link
                key={`${v.id}-${i}`}
                to={path}
                data-testid={`trending-video-${v.id}`}
                className="group shrink-0 w-72 bg-white border border-sand-200 hover:border-brand-500 transition-colors"
              >
                <div className="aspect-video bg-sand-900 relative overflow-hidden">
                  <img src={v.thumbnail_url || BRAND_VIDEO_POSTER} alt={v.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute top-2 right-2 bg-sand-900/80 text-sand-50 px-2 py-1 backdrop-blur-sm">
                    <ViewsBadge count={v.views} />
                  </div>
                </div>
                <div className="p-3">
                  <div className="font-serif text-base font-bold text-sand-900 leading-tight truncate">{v.title}</div>
                  <div className="font-mono text-[9px] tracking-widest uppercase text-forest-500 mt-1 truncate">{v.entity_name || v.city}</div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
